module.exports = __webpack_public_path__ + "static/media/05C.01ec3799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/05C.png
// module id = 280
// module chunks = 0